import React, { useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import Overlay from "../../../SharedComponents/Overlay";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import ApplicationCardList from "./Applications/ApplicationCardList";
import Notification from "./Notifications/Notification";
import Statistics from "./Statistics/Statistics";
import { getCompanyStatistics } from "../Store/Thunk";
import StatisticsModal from "./Statistics/StatisticsModal";

const AdminDash = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const companyId = useSelector((state) => state.auth.user?.companyUser?.company?.companyId);
  const isLoading = useSelector((state) => state.adminDash.isLoading);

  useEffect(() => {
    dispatch(getCompanyStatistics({ companyId }));
  }, []);

  return (
    <>
      <StatisticsModal />
      {isLoading && <Overlay />}

      <Row style={{ marginTop: "-25px" }}>
        <Col className="px-0">
          <ApplicationCardList />
        </Col>
      </Row>

      <Row className="justify-content-center justify-content-lg-between mx-0">
        <Col xs={12} lg={9}>
          <Row className="mb-3 text-14 text-color-gray-light">
            <Col xs="auto" className="align-content-center">
              {t("adminDashboardNotificationsLabel")}
            </Col>
          </Row>
        </Col>
        <Col xs={12} lg={3} className="d-none d-lg-block">
          <Row className="mb-3 text-14 text-color-gray-light justify-content-center">
            <Col xs="auto" className="align-content-center">
              {t("adminDashboardCompletedAssessmentsLabel")}
            </Col>
          </Row>
        </Col>
      </Row>

      <Row className="mx-0">
        <Col xs={12} lg={9} className="mb-3">
          <Notification />
        </Col>
        <Col xs={12} lg={3} className="mb-3">
          <Row className="mb-3 mt-3 text-14 text-color-gray-light justify-content-center d-lg-none d-block">
            <Col xs="auto" className="align-content-center text-center">
              {t("adminDashboardCompletedAssessmentsLabel")}
            </Col>
          </Row>
          <Statistics />
        </Col>
      </Row>
    </>
  );
};

export default AdminDash;
